import * as yup from "yup";

yup.setLocale({
  mixed: {
    required: "",
  },
});

export default yup;
